import React, {useState, useEffect, useContext} from 'react';
import { listNotifications } from '../../../services/notifications'
import UserContext from '../../../contexts/UserContext';
import { Loader, Dimmer, Tab, Comment, Checkbox } from 'semantic-ui-react'

import NotificationItem from '../../components/NotificationItem';
import NotificationsForm from '../../components/NotificationsForm'

import { fetchA4hRoomId } from '../../../services/registrants'
import { sendAlexaDeviceNotification, sendAlexaProactiveSuggestion } from '../../../services/notifications'

import './style.less'

const CommunityNotifications = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [activeNotifications, setActiveNotifications] = useState([])
    const [historyNotifications, setHistoryNotifications] = useState([])
    const [errorMsg, setErrorMsg] = useState('')
    const [filterMyActiveNotifications, setFilterMyActiveNotifications] = useState(false)
    const [filterMyHistoryNotifications, setFilterMyHistoryNotifications] = useState(false)

    const {
        userObject: {
            registrants: { list: listOfResidents, activeRegistrantsIndexes },
            profile: { _id: userId, Image: userProfileImage },
        },
    } = useContext(UserContext);

    const fetchNotifications = async () => {
        setIsLoading(true)

        const selectedResident = listOfResidents[activeRegistrantsIndexes[0]]
        console.log('Selected resident: ', selectedResident)
        const facilityId = selectedResident.Facility
        if (facilityId) {
            const localNotificationsList = await listNotifications(facilityId)
            console.log('notificationsList: ', localNotificationsList)

            let localActiveNotifications = localNotificationsList.filter(notification => {
                const now = new Date().toISOString();
                const endDate = notification.EndDate || '';
                return now < endDate
            })
            localActiveNotifications.sort((notif1, notif2) => {
                return notif2.DateAdded - notif1.DateAdded
            })

            let localHistoryNotifications = localNotificationsList.filter(notification => {
                const now = new Date().toISOString();
                const endDate = notification.EndDate || '';
                return now > endDate
            })
            localHistoryNotifications.sort((notif1, notif2) => {
                return notif2.DateAdded - notif1.DateAdded
            })
            
            setActiveNotifications(localActiveNotifications)
            setHistoryNotifications(localHistoryNotifications)

        } else {
            console.log('This is not a facility resident')
        }

        setIsLoading(false)
    }

    const notificationPanes = [
        {
            menuItem: 'Active',
            render: () => {
                let localActiveNotifications = [...activeNotifications]
                if (filterMyActiveNotifications) {
                    localActiveNotifications = localActiveNotifications.filter(notification => {
                        return notification.relativeUserId === userId
                    })
                }
                return (
                    <Tab.Pane attached={false}>
                        {activeNotifications.length
                        ?
                            <>
                            <Checkbox 
                                label='Filter My Notifications' 
                                checked={filterMyActiveNotifications}
                                onChange={(e, data) => {
                                    setFilterMyActiveNotifications(data.checked)
                                }}
                            />
                            <br/>
                            <br/>
                            </>
                        : ''
                        }
                        {localActiveNotifications.length > 0
                        ?   <>
                                <Comment.Group>
                                    {localActiveNotifications.map(notification => {
                                        const userName = (notification.relativeUserId === userId) ? 'Me' : 'Facility Staff'
                                        const imageUrl = (notification.relativeUserId === userId) ? (userProfileImage || null) : null
                                        return (
                                            <NotificationItem 
                                                key={notification._id} 
                                                userName={userName} 
                                                imageUrl={imageUrl} 
                                                notification={notification} 
                                            />
                                        )
                                    })}
                                </Comment.Group>
                            </>
                        :   'No active notifications'
                        }
                    </Tab.Pane>
                )
            },
        },
        {
            menuItem: 'History',
            render: () => {
                let localHistoryNotifications = [...historyNotifications]
                if (filterMyHistoryNotifications) {
                    localHistoryNotifications = localHistoryNotifications.filter(notification => {
                        return notification.relativeUserId === userId
                    })
                }
                return (
                    <Tab.Pane attached={false}>
                        {historyNotifications.length 
                        ?
                            <>
                            <Checkbox 
                                label='Filter My Notifications' 
                                checked={filterMyHistoryNotifications}
                                onChange={(e, data) => {
                                    setFilterMyHistoryNotifications(data.checked)
                                }}
                            />
                            <br/>
                            <br/>
                            </>
                        : ''
                        }
                        {localHistoryNotifications.length > 0
                        ?   
                            <>
                                <Comment.Group>
                                    {localHistoryNotifications.map(notification => {
                                        const userName = (notification.relativeUserId === userId) ? 'Me' : 'Facility Staff'
                                        const imageUrl = (notification.relativeUserId === userId) ? (userProfileImage || null) : null
                                        return (
                                            <NotificationItem 
                                                key={notification._id} 
                                                userName={userName} 
                                                imageUrl={imageUrl} 
                                                notification={notification} 
                                            />
                                        )
                                    })}
                                </Comment.Group>
                            </>
                        :   'No past notifications'
                        }
                    </Tab.Pane>
                )
            },
        }
    ]

    useEffect(() => {
        fetchNotifications()
    }, [activeRegistrantsIndexes])

    const handleSend = async (subject, message, endDateISO) => {
        setIsLoading(true)
        try {
            const selectedResident = listOfResidents[activeRegistrantsIndexes[0]]
            const registrantId = selectedResident._id
            const facilityId = selectedResident.Facility
            const { a4hRoomId } = await fetchA4hRoomId(registrantId, facilityId)
            const relativeUserId = userId

            await sendAlexaDeviceNotification(message, [a4hRoomId], relativeUserId, facilityId)
            await sendAlexaProactiveSuggestion(subject, message, [a4hRoomId], endDateISO, relativeUserId, facilityId)
            await fetchNotifications()
        } catch(error) {
            console.error(error)

        }
        setIsLoading(false)
    }
    
    return (
        <div className="Notifications">
            <Dimmer active={isLoading} inverted>
                <Loader active={isLoading} />
            </Dimmer>
            <h1>Notifications</h1>
            <NotificationsForm 
                onSubmit={handleSend}
                isSaving={isLoading} 
            />
            <Tab 
                menu={{ secondary: true, pointing: true }} 
                panes={notificationPanes}
            />
        </div>
    )
}

export default CommunityNotifications
